import "dark-mode-toggle"

const toggle = document.querySelector("dark-mode-toggle")
const html = document.documentElement

toggle.setAttribute("permanent", "");

toggle.mode == "dark" ? html.classList.add("dark") : html.classList.remove("dark")

toggle.addEventListener("colorschemechange", () => {
	html.classList.toggle("dark", toggle.mode === "dark")
})
